import { Component, EventEmitter, OnInit, OnDestroy, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Menu, MenuItem, Listbox } from 'primeng/primeng';

import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/distinctUntilChanged';

import { CUISearchItem } from './cui-search-item';

declare let objectPath: any;

@Component({
    selector: 'cui-search-list',
    templateUrl: './cui-search-list.component.html',
    styleUrls: ['./cui-search-list.component.css'],
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class CUISearchListComponent implements OnInit, OnDestroy {
    @Input() currentSelection: string;
    @Input() emptyDisplayMessage: string = 'No items found.';
    @Input() items: CUISearchItem[] = [];
    @Input() searchPlaceholder: string = 'Search list';
    @Input() title: string;
    @Input() menuOptions: MenuItem[];
    @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();

    //YH 2/28/2017 Bug 118831 - All Input Forms - User is not prompted when leaving a screen with unsaved changes
    @Input() currentSelectionObservable:Subject<string>;

    private init: CUISearchItem[] = [];
    private searchFilter:FormControl = new FormControl();
    private searchSubscription: Subscription;
    private selectedItem: string;

    //YH 1/26/2017
    @ViewChild('listBoxControl')
    listBoxControl: Listbox;

    //YH 4/27/2017 Bug 127978 - Add new User stays in Groups page
    @ViewChild('menu')
    menu:Menu;

    ngOnInit(): void {
        //this.searchSubscription = this.searchFilter.valueChanges
        //    .debounceTime(250)
        //    .distinctUntilChanged()
        //    .subscribe(search => this.filterItems(search));
    }

    ngOnDestroy(): void {
        this.searchSubscription.unsubscribe();
        //YH 4/27/2017 Bug 127978 - Add new User stays in Groups page
        this.menu.hide();
    }

    ngOnChanges(changes) {
        if (changes.currentSelection) {
            this.selectedItem = changes.currentSelection.currentValue;
        }
        //YH 1/25/2017 Per Ben's requirements by an email from 1/25/2017 3:02pm
        //SJ 1/31/2017 Commenting out change at Yaron's request after the change cuased a refresh issue with the account form.
       // if (changes.items)
       //     this.ngOnChangesSimpleChange(changes);
    }

    ngAfterViewInit() {
        //YH 2/28/2017 Bug 118831 - All Input Forms - User is not prompted when leaving a screen with unsaved changes
        this.subscribeToExternalSelection();
    };

    private ngOnChangesSimpleChange(changes) {
        //YH 1/25/2017 Per Ben's requirements by an email from 1/25/2017 3:02pm
        //If an items in a list is deleted, select the next item after.
        //If the deleted item is the last in the list, select the item before
        let itemDeleted = objectPath.has(changes,"items.currentValue") &&
                          objectPath.has(changes,"items.previousValue") &&
                          changes.items.currentValue.length < changes.items.previousValue.length;
        if (itemDeleted) {
            //console.debug("CUISearchListComponent ngOnChangesSimpleChange() item deleted ");
            let deletedItemIndex:number = -1;
            let i:number = 0;
            while (deletedItemIndex==-1 && i<changes.items.currentValue.length )
            {
                let currentValue:CUISearchItem = changes.items.currentValue[i];
                let previousValue:CUISearchItem = changes.items.previousValue[i];
                if (!currentValue.equals(previousValue))
                {
                    deletedItemIndex = i;
                }
                i++;
            }
            //console.debug("CUISearchListComponent ngOnChangesSimpleChange() deletedItemIndex="+deletedItemIndex);
            if (deletedItemIndex == 0 )
                this.selectedItem = objectPath.get(changes.items.currentValue,0);
            else if (deletedItemIndex < 0 || deletedItemIndex+1 >= changes.items.currentValue.length)
                this.selectedItem = objectPath.get(changes.items.currentValue,changes.items.currentValue.length-1);
            else
                this.selectedItem = objectPath.get(changes.items.currentValue,deletedItemIndex+1);

            //console.debug("CUISearchListComponent ngOnChangesSimpleChange() next item:");
            //console.debug(this.selectedItem);
            let selectedItemValue = objectPath.get(this.selectedItem,"value",null);
            this.emitSelection(selectedItemValue);
        }

    }
    /**
     * @function emits a onSelectionChange event to the implementing feature component
     * @returns void
     */
    emitSelection(selectedItem: string): void {
        this.onSelectionChange.emit({
            value: selectedItem
        });
    }

    /**
     * @function filter list of items based on search query
     * @returns void
     */
    filterItems(searchQuery: string) {
        if (this.init.length === 0) {
            this.init = this.items;
        }
        this.items = (searchQuery == '')
            ? this.init
            : this.init.filter(item => item.label.toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0);
    }

    /**
     * @function returns true when submenu options are available
     * @returns boolean
     */
    get hasMenuOptions(): boolean {
        let hasSubmenuOptions = this.menuOptions && this.menuOptions.length ? true : false;
        return hasSubmenuOptions;
    }

    //YH 2/28/2017 Bug 118831 - All Input Forms - User is not prompted when leaving a screen with unsaved changes
    private subscribeToExternalSelection() {
        if (this.currentSelectionObservable) {
            this.currentSelectionObservable.subscribe(value=> {
                //this.listBoxControl.writeValue is the way that PrimeNG came up with for setting the selected value of the list
                if (this.listBoxControl) {
                    if (value === undefined || value === null)
                        value = "";
                    this.listBoxControl.writeValue(value);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-search-list/cui-search-list.component.ts